/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Frontrow_Step_InvoicedInputs */

const en_scene_frontrow_step_invoiced = /** @type {(inputs: Scene_Frontrow_Step_InvoicedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invoiced`)
};

/**
* | output |
* | --- |
* | "Invoiced" |
*
* @param {Scene_Frontrow_Step_InvoicedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const scene_frontrow_step_invoiced = /** @type {((inputs?: Scene_Frontrow_Step_InvoicedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Frontrow_Step_InvoicedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_scene_frontrow_step_invoiced(inputs)
});